import React, { useState } from "react";
import Sugar from "sugar";

import ScorecardCollegeInfoPanel from "./ScorecardCollegeInfoPanel";
import ScorecardExpandablePanel from "./ScorecardExpandablePanel";

import ScorecardDetailPanel from "./ScorecardDetailPanel";
import ScorecardDetailStats from "./ScorecardDetailStats";
import ScorecardDetailSparkChart from "./ScorecardDetailSparkChart";

import SocialLinks from "../SocialLinks";

import { isSameScorecard, isSameMajor, getHighestLowest, getMainCampus, splitSchoolName } from "../Helpers.js";
import { useData } from '../data/DataHooks'

import ClearbitImage from '../ClearbitImage'

import ScorecardCollegeMap from './ScorecardCollegeMap'

import { TrackingLink } from "../modules/TrackingLink";

import cx from 'classnames';

// import styles from './styles.scss'


Sugar.extend();

function Scorecard({ decorated, scorecard, majors, navigation, children }) {

  const [backgroundImage, setBackgroundImage] = useState("");


  // TODO: Implement subcampus reduction
  // const reducedMajors = majors.unique( x => x.opeid6 ).map( x => isSameScorecard(x, scorecard) ? x : (getMainCampus(x, majors) || x) );
  const reducedMajors = majors;

  const majorsByIncome = reducedMajors.clone().sortBy("income", true);//sort( (a, b) => a.income == b.income ? a.school < b.school ? -1 : 1 : a.income - b.income) );
  const majorsByDebt = reducedMajors.clone().sortBy("debt", true);
  const majorsByPayment = reducedMajors.clone().sortBy("percent", true);

  const rankByIncome = majorsByIncome.findIndex( isSameScorecard.partial(scorecard) ) + 1;
  const rankByDebt = majorsByDebt.findIndex( isSameScorecard.partial(scorecard) ) + 1;


  const percentage = Math.round(
    ((scorecard.payment * 12) / scorecard.income) * 100
  );

  const url = scorecard.url;
  const { school, campus } = splitSchoolName( scorecard && scorecard.school || "" );

  const handleLoaded = ({src}) => setBackgroundImage(src);

//<ClearbitImage url={ scorecard.url} size={200} style={{ position: 'absolute', right: '12px', borderRadius:'100px', width: '200px'}} onLoaded={ handleLoaded }/>

  const linkHeader = (<TrackingLink event="school_url" href={ "//" + url } target="_blank" rel="noopener noreferrer">
    { school } <small><i className="fa fa-external-link"></i></small>{ campus && (<><br/><small>{campus}</small></>) }
  </TrackingLink>);

  const staticHeader = (
    <>{ school } { campus && (<><br/><small>{campus}</small></>) }</>
  )

  const header = url ? linkHeader : staticHeader;

  return (
    <section className="scorecard-detail">

      <div className={ cx("scorecard-header", {decorated: decorated}) } >
        <div className="scrim">
          <div className="scorecard-gradient"></div>
        </div>

      <div className="foreground">

        <div className="text">
          <div className="scorecard-nav">
            <div>{ navigation }</div>
            <div>{ children }</div>
          </div>

        <div className="two-up">
          <ClearbitImage className="logo" url={ url } size={70}/>

          <div>

            <div className="header-meta">Does That Degree Pay?</div>
            <div className="scorecard-school">
              { header }
            </div>
            <div className="scorecard-degree">{scorecard.degree}</div>
            <div className="scorecard-major">{scorecard.major}</div>
            <SocialLinks scorecard={scorecard}/>

          </div>

        </div>

        </div>





        </div>
      </div>


      <div className="scorecard-figures">


      <ScorecardDetailPanel className="scorecard-income" key="income" fill="fill-teal">
          <ScorecardDetailStats>
            <ScorecardDetailStats.Title>
              You'll Make
            </ScorecardDetailStats.Title>

            <ScorecardDetailStats.Value value={ `$${scorecard.income.format(0)}` } ordinal={ <>in first<br/>year</> }/>

            <ScorecardDetailStats.Meta>
              <strong>
                {getHighestLowest(rankByIncome, reducedMajors.length)} income{" "}
              </strong>{" "}
              for this degree and major
            </ScorecardDetailStats.Meta>
            {
              /*
            <ScorecardDetailStats.Meta>
              Median annual income one year after graduation
            </ScorecardDetailStats.Meta>*/}
          </ScorecardDetailStats>
        </ScorecardDetailPanel>

        <ScorecardDetailPanel key="debt" fill="fill-red">
          <ScorecardDetailStats>
            <ScorecardDetailStats.Title>
              You'll Owe
            </ScorecardDetailStats.Title>

            <ScorecardDetailStats.Value value={ `$${scorecard.debt.format(0)}` } ordinal={ <>in&nbsp;federal<br/>debt</> }/>

            <ScorecardDetailStats.Meta>
              <strong>
                {getHighestLowest(rankByDebt, reducedMajors.length)} debt{" "}
              </strong>{" "}
              for this degree and major
            </ScorecardDetailStats.Meta>
          {
            /*
            <ScorecardDetailStats.Meta>
              Median federal debt owed upon graduation
            </ScorecardDetailStats.Meta>
            */}
          </ScorecardDetailStats>
        </ScorecardDetailPanel>

        <ScorecardDetailPanel key="percent" fill="fill-navy">
          <ScorecardDetailStats>
            <ScorecardDetailStats.Title>
              You'll Pay
            </ScorecardDetailStats.Title>

            <ScorecardDetailStats.Value value={ `$${scorecard.payment.format(0)}` } ordinal={ <>per<br/>month</> }/>

            <ScorecardDetailStats.Meta>
              <strong>{percentage}%</strong> of your projected pre-tax income
            </ScorecardDetailStats.Meta>
            {
              /*
            <ScorecardDetailStats.Meta>
              On a standard 10-year repayment plan
            </ScorecardDetailStats.Meta>

            */}
          </ScorecardDetailStats>
        </ScorecardDetailPanel>


        <ScorecardDetailPanel className="full-width" key="compare" fill="fill-black">
            <ScorecardDetailStats>
              <ScorecardDetailStats.Title>
                Compare Schools
              </ScorecardDetailStats.Title>

              <ScorecardDetailStats.Meta>
                <strong>{reducedMajors.length} schools</strong> in the region
                offer {scorecard.degree}s in {scorecard.major}:
              </ScorecardDetailStats.Meta>

              <ScorecardDetailSparkChart
                majors={reducedMajors}
                scorecard={scorecard}
              />

            </ScorecardDetailStats>
          </ScorecardDetailPanel>



      </div>


    </section>
  );
}

export default Scorecard;
